module.exports = __webpack_public_path__ + "assets/img/m3.cc633885.png";